<script>
    import {
        getText,
        getFormatDate,
        getFormatDateAndTime,
        getTitle,
        getEncounterBillingType,
        getEncounterNeuraxialType,
        goToURL,
    } from "../../../../../Utils/utilFunctions.svelte";

    import { CardLayout } from "../../../../../Components/Common/index.svelte";

    export let procedureDetails = {};
    export let doctorDetails = {};

    $: hospitalDetails = { ...procedureDetails.hospital };

    $: surgeonDetails = { ...procedureDetails.surgeon };

    // HELPER FUNCTIONS
    const _getEncounterTypeName = () => {
        const { typeOfBill, neuraxialType } = procedureDetails;

        if (typeOfBill != 2 || !neuraxialType)
            return getEncounterBillingType(typeOfBill);

        return `${getEncounterBillingType(typeOfBill)} (${getEncounterNeuraxialType(neuraxialType)})`;
    };

    const _getDisplayDate = (date) => {
        if (!date) return "";

        const formatDate = getFormatDateAndTime(date);

        const formatDateArr = formatDate.split(", ");

        return formatDateArr[1] == "00:00" ? formatDateArr[0] : formatDate;
    };

    const _getDoctorFullName = () => {
        const { firstName, lastName, title } = doctorDetails;

        return `${getTitle(title)} ${firstName} ${lastName}`;
    };

    const _redirectToDoctor = () =>
        goToURL(`/Account/view/${doctorDetails.id}`);

    const _redirectToHospital = () =>
        goToURL(`/Hospitals/view/${hospitalDetails.id}`);

    const _getSurgeonName = () => {
        const { firstName, lastName, title, speciality } = surgeonDetails;

        return `${getTitle(title)} ${firstName} ${lastName} ${speciality ? `(${speciality})` : ""}`;
    };
</script>

<CardLayout title="Procedure Details">
    <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Encounter Type:</p>
                <p class="content">
                    {_getEncounterTypeName()}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Procedure Name:</p>
                <p class="content">
                    {getText(procedureDetails.procedureName)}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Scheduled Date:</p>
                <p class="content">
                    {_getDisplayDate(procedureDetails.scheduledDate)}
                </p>
            </div>
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Doctor:</p>
                <p
                    class="content plink"
                    on:click|preventDefault={_redirectToDoctor}
                >
                    {_getDoctorFullName()}
                </p>
            </div>

            {#if hospitalDetails.id}
                <div class="flex flex-row gap-x-2">
                    <p class="title">Hospital Name:</p>
                    <p
                        class="content plink"
                        on:click|preventDefault={_redirectToHospital}
                    >
                        {getText(hospitalDetails.name)}{hospitalDetails.state
                            ? `, ${hospitalDetails.state}`
                            : ""}
                    </p>
                </div>
            {:else}
                <p>No Hospital Information...</p>
            {/if}

            {#if surgeonDetails.id}
                <div class="flex flex-row gap-x-2">
                    <p class="title">Surgeon/Referrer Name:</p>
                    <p class="content">{_getSurgeonName()}</p>
                </div>
            {:else}
                <p>No Surgeon/Referrer Information...</p>
            {/if}
        </div>

        <div class="divider lg:divider-horizontal" />

        <div class="flex flex-col flex-1 gap-y-4 h-full">
            <div class="flex flex-row gap-x-2">
                <p class="title">Encounter Created Date:</p>
                <p class="content">
                    {getFormatDate(procedureDetails.createdDate)}
                </p>
            </div>

            <div class="flex flex-row gap-x-2">
                <p class="title">Last Updated Date:</p>
                <p class="content">
                    {getFormatDate(procedureDetails.updatedDate)}
                </p>
            </div>
        </div>
    </div>
</CardLayout>

<style>
    .title {
        width: 200px;
    }

    .content {
        width: calc(100% - 200px);
    }
</style>
